// extracted by mini-css-extract-plugin
export default {"links":"VersionChecker_links__plOGi","link":"VersionChecker_link__SJ38s"};